/* 🤖 this file was generated by svg-to-ts */
export const matIconMarkChatUnread: {
  name: 'mark-chat-unread';
  data: string;
} = {
  name: 'mark-chat-unread',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 6.98V16c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1s.04.68.1 1H4v12h16V7.9c.74-.15 1.42-.48 2-.92zM16 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"/></svg>`
};
